var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateComers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.791 10.8101C33.9978 12.4899 34.862 14.3909 35.3341 16.4046C35.8063 18.4183 35.8772 20.5053 35.5428 22.5464C35.2084 24.5875 34.4753 26.5427 33.3852 28.3005C32.2952 30.0583 30.8696 31.5841 29.1899 32.791C27.5101 33.9978 25.6091 34.862 23.5954 35.3341C21.5817 35.8063 19.4947 35.8772 17.4536 35.5428C15.4125 35.2084 13.4573 34.4753 11.6995 33.3852C9.94171 32.2952 8.41585 30.8696 7.20902 29.1899C6.00219 27.5101 5.13803 25.6091 4.66587 23.5954C4.19372 21.5817 4.12281 19.4947 4.45721 17.4536C4.7916 15.4125 5.52475 13.4573 6.61479 11.6995C7.70483 9.94171 9.13041 8.41585 10.8101 7.20902C12.4899 6.00219 14.3909 5.13803 16.4046 4.66587C18.4183 4.19372 20.5053 4.12281 22.5464 4.45721C24.5875 4.7916 26.5427 5.52475 28.3005 6.61479C30.0583 7.70483 31.5842 9.13041 32.791 10.8102L32.791 10.8101Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.4648V21.4648L25 24",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateComers);
export default __webpack_public_path__ + "static/media/late-comers.932589b17154e37ada65935435787205.svg";
export { ForwardRef as ReactComponent };